<template>
    <b-card class="mb-5">
        <b-row>
            <b-col md="6">
                <h3>{{$route.name}} <b-badge variant="success" class="border-radius">New</b-badge></h3>
                <b-breadcrumb>
                <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                <b-breadcrumb-item><router-link to="/new-reimbursement">Reimbursement</router-link></b-breadcrumb-item>
                <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
            <b-col md="6" class="mt-3 text-right" v-if="model.status === 'Requested'">
                <b-button variant="danger" class="btn-sm mr-2" @click="showModal('reject')">
                    <font-awesome-icon icon="times-circle"></font-awesome-icon> Reject
                </b-button>
                <b-button variant="success" class="btn-sm " @click="showModal('approve')">
                    <font-awesome-icon icon="check-circle"></font-awesome-icon> Approve
                </b-button>
            </b-col>
            <!-- <b-col md="6" class="mt-3 text-right" v-if="model.status === 'Approved'">
                <b-button variant="danger" class="btn-sm" @click="showModal('reject')">
                    <font-awesome-icon icon="times-circle"></font-awesome-icon> Reject
                </b-button>
            </b-col> -->
        </b-row>
        <div class="border-bottom mb-3"/>
        <template v-if="isLoading">
            <div class="d-flex justify-content-center mb-5 mt-5 pt-5 pb-5">
                <b-spinner style="width: 3rem; height: 3rem;" variant="primary" label="Loading..."></b-spinner>
            </div>
        </template>
        <b-form class="mt-4 mx-2" v-else>
            <b-row>
                <b-col md="6">
                    <b-row>
                        <b-col md="4">
                            <label class="labels">No. Request</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.noRequest !== null ? model.noRequest : '-' }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Requested By</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.requestedBy !== null ? model.requestedBy : '-' }}</p>
                        </b-col>
                    </b-row>
                    <b-row v-if="model.status !== ''">
                        <b-col md="4">
                            <label class="labels">{{model.status}}</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.status }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Category</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.reimburseCategory !==null ? model.reimburseCategory.journalAccountName : '-' }}</p>
                        </b-col>
                    </b-row>
                     <b-row>
                        <b-col md="4">
                            <label class="labels">Journal Account</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.reimburseCategory.journalAccount !==null ? model.reimburseCategory.journalAccountName : '-' }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Amount</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ dataAccount.account.currency }} {{ formatPrice(model.amount) }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Status</label>
                        </b-col>
                        <b-col md="8">
                            <p><b-badge :variant="getStatusColor(model.status)">{{model.status}}</b-badge></p>
                        </b-col>
                    </b-row>
                    <!-- <div v-if="model.reimburseType === 'Petrol'">
                        <b-row>
                            <b-col md="4">
                                <label class="labels">Total</label>
                            </b-col>
                            <b-col md="8">
                            <p>{{ model.totalPetrol }}</p>
                            </b-col>
                        </b-row>
                    </div>
                    <div v-else>
                        <b-row>
                            <b-col md="4">
                                <label class="labels">Destination</label>
                            </b-col>
                            <b-col md="8">
                            <p>{{ model.destination }}</p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4">
                                <label class="labels">Total Mileage</label>
                            </b-col>
                            <b-col md="8">
                            <p>{{ model.totalMileage }}</p>
                            </b-col>
                        </b-row>
                    </div> -->
                </b-col>
                <b-col md="6">
                    <b-row v-if="model.statusTime !== ''">
                        <b-col md="4">
                            <label class="labels">{{model.statusTextTime}}</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.statusTime }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Created</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.createdAt }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Description</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.note !== null ? model.note : '-' }}</p>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row class="mt-3 mb-3">
                <b-col>
                    <h5 class="pb-3">Photo</h5>
                </b-col>
                <b-col md="12">
                    <b-row v-if="model.reimbursementPhotoList.length === 0">
                        <b-col md="3">
                            <p class="text-secondary text-center border p-5"><i>No Photo Submitted</i></p>
                        </b-col>
                    </b-row>
                    <viewer :images="model.reimbursementPhotoList" v-else>
                        <b-row>
                            <b-col md="3" v-for="(src, index) in model.reimbursementPhotoList" :key="index">
                                <p class="text-secondary text-center border p-5" v-if="src === null"><i>No Photo Submitted</i></p>
                                <b-img v-else :src="src" class="img-responsive" width="300" height="200"/>
                            </b-col>
                        </b-row>
                    </viewer>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h5 class="mb-3 mt-3">Reimbursement Status History</h5>
                </b-col>
                <b-col md="12">
                    <div class="table-responsive">
                    <table class="table table-hovered table-striped">
                        <thead>
                            <tr>
                                <th scope="col" width="100">Status</th>
                                <th scope="col" width="250">Changed By</th>
                                <th scope="col">Note</th>
                                <th scope="col" width="200">Time</th>
                            </tr>
                        </thead>
                        <tbody v-if="reimbursementHistoryStatusList.length > 0">
                        <tr v-for="reimbursement in reimbursementHistoryStatusList" :key="reimbursement.uuid">
                            <td><b-badge :variant="getStatusColor(reimbursement.status)">{{reimbursement.status}}</b-badge></td>
                            <td>{{reimbursement.changedBy}}</td>
                            <td>{{reimbursement.note !== null ? reimbursement.note : '-'}}</td>
                            <td>{{reimbursement.createdAt !== null ? getDateTime(reimbursement.createdAt) : '-'}}</td>
                        </tr>
                        </tbody>
                        <tbody v-else>
                        <tr>
                            <td colspan="9" class="text-center">there's no data</td>
                        </tr>
                        </tbody>
                    </table>
                    </div>
                </b-col>
            </b-row>
        </b-form>
        <b-button class="mt-3" @click="goBack" variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>

        <b-modal id="bv-modal-example" hide-footer>
            <template v-slot:modal-title>
                <h5 class="text-transform">{{type}} Reimbursement</h5>
            </template>
            <form v-on:submit.prevent="doChangeStatus(type)">
                <div class="d-block">
                    <label class="labels" for="">Note</label>
                    <b-form-textarea rows="3" v-model="formData.note" placeholder="Enter Note"></b-form-textarea>
                </div>
                <b-button class="mt-4" @click="$bvModal.hide('bv-modal-example')"><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button>
                <b-button variant="primary" type="submit" class="mt-4 float-right"><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon> <font-awesome-icon icon="save" v-else></font-awesome-icon> Submit</b-button>
            </form>
        </b-modal>
    </b-card>
</template>

<script>
    import 'viewerjs/dist/viewer.css'
    import Viewer from 'v-viewer'
    import Vue from 'vue'
    Vue.use(Viewer)

    export default {
        name: 'reimbursement-show',
        data () {
            return {
                isLoading: false,
                dataAccount: this.$store.getters['account/accountData'],
                apiUrl: {
                    reimbursement: window.AppConfig.apiUrl + 'reimbursement',
                    reimbursementPhoto: window.AppConfig.apiUrl + 'reimbursement-photo',
                    reimbursementHistoryStatus: window.AppConfig.apiUrl + 'reimbursement-history-status'
                },
                type: null,
                formData: {
                    note: null
                },
                // mainProps: { blank: true, width: 75, height: 75, class: 'm1' },
                model: {
                    noRequest: '',
                    amount: '',
                    requestedBy: {
                        name: null
                    },
                    startTime: '',
                    endTime: '',
                    status: '',
                    note: '',
                    createdAt: '',
                    changedBy: '',
                    reimbursementPhotoList: [],
                    reimburseType: null,
                    reimburseCategory: [],
                    statusValue: '',
                    statusText: '',
                    statusTime: '',
                    statusTextTime: '',
                    destination: '',
                    totalMileage: '',
                    totalPetrol: '',
                },
                reimbursementHistoryStatusList: []
            }
        },
        mounted () {
            this.getDetail()
            this.getHistoryStatus()
        },
        methods: {
            showModal (type) {
                this.formData.note = null
                this.type = type
                this.$bvModal.show('bv-modal-example')
            },
            doChangeStatus (type) {
                this.isLoading = true
                let model = {
                    uuid: this.$route.params.uuid,
                    action: type,
                    note: this.formData.note
                }
                this.$http.post(window.AppConfig.apiUrl + 'reimbursement-action', model)
                .then(() => {
                    this.isLoading = false
                    this.formData.note = null
                    this.$bvModal.hide('bv-modal-example')
                    this.getDetail()
                    this.getHistoryStatus()
                    this.$store.dispatch('notification/success', 'Reimbursement has been ' + type)
                })
                .catch(error => {
                    this.isLoading = true
                    this.$store.dispatch('notification/error', error)
                });
            },
            getDetail () {
                this.isLoading = true
                this.$http.get(this.apiUrl.reimbursement + '/' + this.$route.params.uuid)
                .then(response => {
                    this.model.noRequest = response.data.noRequest !== null ? response.data.noRequest : '-'
                    this.model.requestedBy = response.data.requestedBy !== null ? response.data.requestedBy.name : '-'
                    this.model.startTime = response.data.startTime !== null ? response.data.startTime : '-'
                    this.model.endTime = response.data.endTime !== null ? response.data.endTime : '-'
                    this.model.status = response.data.status !== null ? response.data.status : '-'
                    this.model.note = response.data.note !== null ? response.data.note : '-'
                    this.model.createdAt = response.data.createdAt !== null ? this.$moment(response.data.createdAt).format('YYYY-MM-DD hh:mm A') : '-'
                    this.model.amount = response.data.amount !== null ? response.data.amount : '-' 
                    if (response.data.rejectedBy !== null && response.data.status === 'Rejected') {
                        this.model.statusText = 'Rejected By'
                        this.model.statusTextTime = 'Rejected Time'
                        this.model.statusValue = response.data.rejectedBy
                        this.model.statusTime = response.data.rejectedTime !== null ? this.$moment(response.data.rejectedTime).format('YYYY-MM-DD hh:mm A') : '-'
                    }
                    if (response.data.approvedBy !== null && response.data.status === 'Approved') {
                        this.model.statusText = 'Approved By'
                        this.model.statusTextTime = 'Approved Time'
                        this.model.statusValue = response.data.approvedBy
                        this.model.statusTime = response.data.approvedTime !== null ? this.$moment(response.data.approvedTime).format('YYYY-MM-DD hh:mm A') : '-'
                    }
                    if (response.data.paidBy !== null) {
                        this.model.statusText = 'Paid By'
                        this.model.statusTextTime = 'Paid Time'
                        this.model.statusValue = response.data.paidBy
                        this.model.statusTime = response.data.paidTime !== null ? this.$moment(response.data.paidTime).format('YYYY-MM-DD hh:mm A') : '-'
                    }
                    this.model.reimbursementPhotoList = []
                    if (response.data.reimbursePhoto !== null) {
                        response.data.reimbursePhoto.forEach(data => {
                            this.model.reimbursementPhotoList.push(data.url)
                        })
                    }
                    this.model.reimburseCategory = response.data.reimburseCategory !== null ? response.data.reimburseCategory : '-'
                    this.model.reimburseCategory = response.data.reimburseCategory !== null ? response.data.reimburseCategory.journalAccount : '-'
                    this.model.reimburseType = response.data.reimburseType !== null ? response.data.reimburseType.name : '-'
                    if(this.model.reimburseType === 'Petrol'){
                        this.model.totalPetrol = response.data.options !== null ? response.data.options[0].value : '-'
                    }else{
                      this.model.destination = response.data.options !== null ? response.data.options[0].value : '-'
                      if (response.data.options !== null && response.data.options.length > 1) {
                          this.model.totalMileage = response.data.options !== null ? response.data.options[1].value : '-'
                      }
                    }
                })
                .catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                })
            },
            formatPrice(value) {
                let val = (value/1).toFixed(2).replace(',', '.')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            getHistoryStatus () {
                this.isLoading = true
                this.$http.get(this.apiUrl.reimbursementHistoryStatus + '?reimburse_uuid=' + this.$route.params.uuid + '&ascending=1').then(response => {
                    this.reimbursementHistoryStatusList = []
                    response.data._embedded.reimbursementHistoryStatus.forEach(data => {
                        this.reimbursementHistoryStatusList.push(data)
                    })
                    this.isLoading = false
                })
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD HH:mm A')
                } else {
                    return '-'
                }
            },
            goBack () {
                window.goBack(this)
            },
            getStatusColor (val) {
                switch (val) {
                case 'Approved':
                    return 'success'
                    // eslint-disable-next-line no-unreachable
                    break
                case 'Requested':
                    return 'info'
                    // eslint-disable-next-line no-unreachable
                    break

                case 'Rejected':
                    return 'danger'
                    // eslint-disable-next-line no-unreachable
                    break
                case 'Paid':
                    return 'primary'
                    // eslint-disable-next-line no-unreachable
                    break
                }
            },
            hasRole (name) {
              let temp = false
              name.forEach((key) => {
                if (this.$store.getters['account/accountData'].role == key){
                  temp = true
                }
              })
              return temp
            }
        }
    }
</script>